import {Helmet} from "react-helmet";
import React from "react";
import {Box, Container, Paper} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import ColorStandardizationList from "../components/config/colors/ColorStandardizationList";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  }
}));

function ColorStandardizationPage() {
  const classes = useStyles();

  return (
    <div>
      <Helmet>
        <title>Standaryzacja kolorów | GO-auto - Panel administracyjny</title>
      </Helmet>
      <Box
        style={{
          minHeight: '100%'
        }}
      >
        <Container maxWidth={false}>
          <Box pt={1}>
            <Paper className={classes.paper}>
                <ColorStandardizationList />
            </Paper>
          </Box>
        </Container>
      </Box>
    </div>
  )
}

export default ColorStandardizationPage;
